<template>
    <!-- TODO: make column width configurable -->
    <div class="input-group col-9 position-relative">
        <div class="input-group-prepend">
            <div class="input-group-text text-truncate">
                Verification link
            </div>
        </div>
        <a v-show="!error && value"
           class="eye-button fal fa-eye fs-1"
           target="_blank"
           :href="verificationLink">
        </a>
        <i class="eye-button fal fa-eye fs-1" v-show="error || !value"></i>
        <input type="text"
               placeholder="Empty"
               ref="input"
               class="form-control"
               maxlength="254"
               :disabled="disabled"
               :name="name + '-verification'"
               :class="{ 'is-invalid': error }"
               :value="value"
               @input="handleInput($event.target.value)"
               :required="required"/>
        <div v-if="error" class="invalid-feedback">
            {{ error }}
        </div>
    </div>
</template>

<script>
    const EVENTS = {
        INPUT: 'input',
    }

    export default {
        name: 'verification-field',
        props: {
            inputGroupClass: {type: String, default: ''},
            value: {},
            error: {type: String, default: ''},
            name: {type: String, required: true},
            required: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
        },
        computed: {
            verificationLink() {
                if (this.value && this.value.indexOf('//') === -1) {
                    return 'http://' + this.value;
                }
                return this.value;
            }
        },
        methods: {
            handleInput,
        },
    };

    function handleInput(value) {
        this.$refs.input.value = value;
        this.$emit(EVENTS.INPUT, value);
    }

</script>
